var moreservicesInit = function () {

    var servicenavContainer = $('[data-id="service-nav"]'),
        serviceNavButton = $('[data-id="servicenav-button"]'),
        moreButton = $('[data-id="moreservices-button"]'),
        morebuttonText = moreButton.find('[data-id="more-toggle"]'),
        servicenavList = servicenavContainer.find('> ul > li:last-child');

    moreButton.on("click", function (evt) {

        var loadedList = $('[data-id="moreservices"]');

        evt.preventDefault();
        $(this).toggleClass('btn-fewer');
        serviceNavButton.removeClass('active');
        $('[data-id="servicenav-content"]').hide();


        if (loadedList[0]) {
            morebuttonText.text('Show more');
            moreButton.attr('aria-expanded', false);
            servicenavContainer.removeClass('open');
            loadedList.remove();
        }
        else {
            morebuttonText.text('Show fewer');
            moreButton.attr('aria-expanded', true);
            servicenavContainer.addClass('open');

            $.get(mando.strings.URL_MoreService, function (moredata) {
                servicenavList.after(moredata);

                servicenavInit($('[data-id="servicenav-button"]'), $('[data-id="servicenav-content"]'));

                // move focus to first new service
                servicenavContainer.find('li[data-id="moreservices"]:first > a').focus();
                // Re-fire Selectivizr.js for psuedo selector support
                if ($("html").hasClass("ie8")) {
                    Selectivizr.init();
                }
            });
        }
    });


    if (window.location.hash === '#services') {
        moreButton.trigger('click');

        var servicemenu = $('#servicemenu');
        var offset = servicemenu.offset();
        $('html, body').animate({
            scrollTop: offset.top
        }, 1000);

    };


}

